////////////////////////////////////////////////////
import {KS_VerifySignDatas,
  KS_GetCerts,
  KS_SetProvs,
  KS_GetCertInfos,
  KS_SignDatas
} from "./xjl";
//定义相关接口参数
var ALGID_AUTO = 0;							// 自动识别
// 非对称算法
var ALGID_RSA1024 = 1;						// RSA 1024位算法
var ALGID_RSA2048 = 2;						// RSA 2048位算法
var ALGID_ECC = 3;							// SM2 256位算法

// 摘要算法
var ALGID_HASH_SHA1 = 1;					//SHA-1算法
var ALGID_HASH_SHA256 = 2;  				//SHA-256算法
var ALGID_HASH_SHA512 = 3;  				//SHA-512算法
var ALGID_HASH_MD5 = 4;     				//MD5算法
var ALGID_HASH_MD4 = 5; 					//MD4算法
var ALGID_HASH_SM3 = 6;						//SM3算法

// 证书类型定义
var ENCRYPT_TYPE = 1;						//加密证书
var SIGN_TYPE = 2;							//签名证书

// 证书基本项
var X509_CERT_VERSION =	1;					// 证书版本
var X509_CERT_SERIAL =	2;					// 证书序列号
var X509_CERT_SIGNALG =	3;					// 证书签名算法标识
var X509_CERT_ISSUER_C = 4;					// 证书颁发者国家(C)
var X509_CERT_ISSUER_O = 5;					// 证书颁发者组织名(O)
var X509_CERT_ISSUER_OU = 6;				// 证书颁发者部门名(OU)
var X509_CERT_ISSUER_S = 7;					// 证书颁发者所在的省、自治区、直辖市(S)
var X509_CERT_ISSUER_CN = 8;				// 证书颁发者通用名称(CN)
var X509_CERT_ISSUER_L = 9;					// 证书颁发者所在的城市、地区(L)
var X509_CERT_ISSUER_E = 10;				// 证书颁发者Email
var X509_CERT_NOTBEFORE = 11;				// 证书有效期：起始日期
var X509_CERT_NOTAFTER = 12;				// 证书有效期：终止日期
var X509_CERT_SUBJECT_C = 13;				// 证书拥有者国家(C )
var X509_CERT_SUBJECT_O = 14;				// 证书拥有者组织名(O)
var X509_CERT_SUBJECT_OU = 15;				// 证书拥有者部门名(OU)
var X509_CERT_SUBJECT_S = 16;				// 证书拥有者所在的省、自治区、直辖市(S)
var X509_CERT_SUBJECT_CN = 17;				// 证书拥有者通用名称(CN)
var X509_CERT_SUBJECT_L = 18;				// 证书拥有者所在的城市、地区(L)
var X509_CERT_SUBJECT_E = 19;				// 证书拥有者Email
var X509_CERT_ISSUER_DN = 20;				// 证书颁发者DN
var X509_CERT_SUBJECT_DN = 21;				// 证书拥有者DN
var X509_CERT_DER_PUBKEY = 22;				// 证书公钥信息
var X509_CERT_EXT_CRLDISTRIBUTIONPO = 23;	// CRL发布点
////////////////////////////////////////////////////

// 管理员key类型配置
var ks_provider = "soft_file"; // 介质
var ks_alg = ALGID_AUTO;    // 非对称算法
var ks_path = "C:\\CONT\\?";   // 如果为软算法，对应路径
var ks_manager_path = "C:\\CONT\\?";   // 软证书管理员路径
var ks_hash_alg = ALGID_AUTO; // 签名摘要算法

var path = "C:\\CONT\\?"; // 软证书默认保存路径

if(IsIE()){
   document.write("<object id=\"SecCtrl\" classid=\"clsid:17F8D3CF-857C-4D7C-9355-7A2398930B6A\" hidden=\"true\" width=\"0\" height=\"0\" >");
   document.write("</object>");
}else {
   document.write("<embed id=\"SecCtrl\" type=\"application/npsecctrl-plugin\"  hidden=\"true\" width=\"0\" height=\"0\"/>");
}

var SecCtrl = document.getElementById("SecCtrl");

function IsIE(){
	//判断是否为IE内核浏览器
	var u = window.navigator.userAgent.toLocaleLowerCase();
	var msie = /(msie) ([\d.]+)/;
	var chrome = /(chrome)\/([\d.]+)/;
	var firefox = /(firefox)\/([\d.]+)/;
	var safari = /(safari)\/([\d.]+)/;
	var opera = /(opera)\/([\d.]+)/;
	var ie11 = /(trident)\/([\d.]+)/;
	var b = u.match(msie)||u.match(chrome)||u.match(firefox)||u.match(safari)||u.match(opera)||u.match(ie11);
	if(b[1] == "msie" || b[1] == 'trident'){
		return true;
	}else{
		return false;
	}
}
/**
* 获取插Key状态
*/
function GetDeviceStatus() {
    var result = "";
    var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
    if (lRet == 0)
        result = SecCtrl.KS_GetDeviceStatus();
    else
        result = "SetProv error.";
    return result;
}

/**
 * 数据签名P7
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：签名数据
 */
function SignDataByP7(indata, hashAlg){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	SecCtrl.KS_SetParam("signtype", "pksc7");
	result = SecCtrl.KS_SignData(indata, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}
/**
* 获取插KeyVid
*/
function GetDeviceVid() {
    var result = "";
    var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
    if (lRet == 0)
        result = SecCtrl.KS_GetDeviceVid();
    else
        result = "SetProv error.";
    return result;
}

/**
 * 初始化函数，设置相关初始值
 * p_provider: 算法提供者
 * p_alg: 非对称算法，1-RSA1024, 2-RSA2048, 3-ECC
 * p_path: 路径
 */
function init(p_provider, p_alg, p_path){
  var result = 0;
    if(p_provider != null && p_provider != ""){
    	ks_provider = p_provider;
    }
    if(p_alg != null && p_alg != ""){
    	ks_alg = p_alg;
    }
    if(p_path != null && p_path != ""){
    	ks_path = p_path;
    }
    if(IsIE()){
      var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
      if(lRet != 0){
        alert(SecCtrl.KS_GetLastErrorMsg());

      }
      result=lRet;
      return result;
    }else{
      result=KS_SetProvs(ks_provider,ks_alg,ks_path);
      return result;
    }
}

/**
 * 获取版本号
 */
function GetVersion(){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_GetVersion();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 设置过滤器，在算法提供者为soft_ie的时候适用
 * filter: 参数;
例如:CERT_SN=1234&ISSUER_C=CN&ISSUER_CN=测试证书&ISSUER_O=测试单位&ISSUER_OU=测试证书&ISSUER_L=城市&ISSUER_S=省份&ISSUER_E=yangxunx@foxmail.com&SUBJECT_C=CN&SUBJECT_CN=测试证书&SUBJECT_O=测试单位&SUBJECT_OU=测试证书&SUBJECT_L=城市&SUBJECT_S=省份&SUBJECT_E=yangxunx@foxmail.com
 */
 function SetFilter(filter){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_SetParam("filter", filter);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
 }

/**
 * 生成密钥对，返回Base64编码的公钥
 * signCert: Base64编码签名证书
 */
function GenKeyPair(){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_GenKeyPair();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成密钥对，返回Base64编码的公钥
 * signCert: Base64编码签名证书
 * certsn  : 排除此证书序列号的key
 */
function GenKeyPairEx(certsn){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	SecCtrl.KS_SetParam("managersn", certsn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	result = SecCtrl.KS_GenKeyPair();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成证书请求文件
 * dn: 格式为C=CN,CN=测试,O=测试组织,OU=测试部门,L=上海市,S=上海市，E=admin@163.com
 * hashAlg: 签名摘要算法
 */
function MakeP10(dn, hashAlg){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	//填充默认密码
	SecCtrl.KS_SetParam("defaultpin","111111");
	result = SecCtrl.KS_MakeP10(dn, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成证书请求文件（双key，排除管理员key）
 * dn: 格式为C=CN,CN=测试,O=测试组织,OU=测试部门,L=上海市,S=上海市，E=admin@163.com
 * hashAlg: 签名摘要算法
 * certsn  : 排除此证书序列号的key
 */
function MakeP10Ex(dn, hashAlg,certsn){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	SecCtrl.KS_SetParam("managersn", certsn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	result = SecCtrl.KS_MakeP10(dn, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 保存证书
 * signCert: Base64编码签名证书
 * encCert : Base64编码加密证书
 * encKey  : Base64编码加密私钥
 */
function SaveCert(signCert, encCert, encKey){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	SecCtrl.KS_SetParam("defaultpin", "111111");
	lRet = SecCtrl.KS_SaveCert(signCert, encCert, encKey);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}

/**
 * 保存证书
 * signCert: Base64编码签名证书
 * encCert : Base64编码加密证书
 * encKey  : Base64编码加密私钥
 * certsn  : 排除此证书序列号的key
 */
function SaveCertEx(signCert, encCert, encKey,certSn){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	//设置管理员key
	SecCtrl.KS_SetParam("managersn", certSn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	lRet = SecCtrl.KS_SaveCert(signCert, encCert, encKey);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}

/**
 * 保存证书链
 * p7bCertChain: Base64编码的P7B格式证书链
 */
function SaveCertChain(p7bCertChain){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}

	lRet = SecCtrl.KS_SaveCertChain(signCertp7bCertChain);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}


/**
 * 获取BASE64编码证书
 * type: 1、加密证书，2、签名证书
 */
function GetCert(type){
  var result = "";
  if(IsIE()){
    result = SecCtrl.KS_GetCert(type);
    if(SecCtrl.KS_GetLastErrorCode() != 0){
      alert(SecCtrl.KS_GetLastErrorMsg());
    }
    return result;
  }else{

    result=KS_GetCerts(type);
    return result;
  }
}

/**
 * 获取BASE64编码证书(管理员)
 * type: 1、加密证书，2、签名证书
 */
function GetCertManager(type){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}

	//选择默认key
	SecCtrl.KS_SetParam("managersn", "");
	//设置默认key
	SecCtrl.KS_SetParam("bmanager", "false");

	result = SecCtrl.KS_GetCert(type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 获取证书信息
 * cert: Base64编码证书
 * item: 解析项。
 * 1、证书版本；2、证书序列号；3、证书签名算法标识；4、证书颁发者国家(C); 5、证书颁发者组织名(O);
 * 6、证书颁发者部门名(OU); 7、证书颁发者所在的省、自治区、直辖市(S); 8、证书颁发者通用名称(CN); 9、证书颁发者所在的城市、地区(L);
 * 10、证书颁发者Email; 11、证书有效期：起始日期; 12、证书有效期：终止日期; 13、证书拥有者国家(C ); 14、证书拥有者组织名(O);
 * 15、证书拥有者部门名(OU); 16、证书拥有者所在的省、自治区、直辖市(S); 17、证书拥有者通用名称(CN); 18、证书拥有者所在的城市、地区(L);
 * 19、证书拥有者Email; 20、证书颁发者DN; 21、证书拥有者DN; 22、证书公钥信息; 23、CRL发布点.
 */
function GetCertInfo(cert, item){
  var result = "";
  if(IsIE()){
    result = SecCtrl.KS_GetCertInfo(cert, item);
    if(SecCtrl.KS_GetLastErrorCode() != 0){
      alert(SecCtrl.KS_GetLastErrorMsg());
    }
    return result;
  }else{

    result=KS_GetCertInfos(cert, item);
    return result;
  }
}

/**
 * 获取证书扩展信息
 * cert: Base64编码证书
 * oid: oid值
 */
function GetCertInfoByOid(cert, oid){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}

	result = SecCtrl.KS_GetCertInfoByOid(cert, oid);
	if(SecCtrl.KS_GetLastErrorCode() != 0 && SecCtrl.KS_GetLastErrorCode() != 0X0002014){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成随机数
 * len: 随机数长度
 */
function GenRandom(len){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}

	result = SecCtrl.KS_GenRandom(len);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 数据摘要
 * indata: 输入数据
 * hashAlg:摘要算法。1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4
 */
function HashData(indata, hashAlg){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_HashData(indata, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 文件摘要
 * filepath: 输入文件路径
 * hashAlg:摘要算法。1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4
 */
function HashFile(filepath, hashAlg){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_HashFile(filepath, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}
/**
 * 数据签名
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：签名数据
 */
function SignData(indata, hashAlg){
  var result = "";
  if(IsIE()){
    result = SecCtrl.KS_SignData(indata, hashAlg);
    if(SecCtrl.KS_GetLastErrorCode() != 0){
      alert(SecCtrl.KS_GetLastErrorMsg());
    }
    return result;
  }else{
    result=KS_SignDatas(indata, hashAlg);
    return result;
  }
}

/**
 * 双key操作时，使用证书序列号对应的key进行签名
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * certSn:  管理员证书序列号
 * return：签名数据
 */
function SignDataManager(indata, hashAlg,certSn){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	//选择默认key
	SecCtrl.KS_SetParam("managersn", certSn.toLowerCase());
	//设置默认key
	SecCtrl.KS_SetParam("bmanager", "true");

	result = SecCtrl.KS_SignData(indata, hashAlg);
	if(result == ""){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	return result;
}

/**
 * 数据验签
 * indata：明文数据
 * signdata：签名数据
 * cert: 证书
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：成功=true，失败=false
 */
function VerifySignData(indata, signdata, cert, hashAlg){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);

	var lRet = SecCtrl.KS_VerifySignData(indata, signdata, cert, hashAlg);
	return lRet;
}
/**
 * 导入P12到设备中
 * certType: 证书类型, 1加密证书 , 2签名证书
 * base64P12Cert: P12证书
 * p12Pin: P12密码
 * return: 返回错误码，0成功，其他失败
 */
function ImportP12Cert(certType, base64P12Cert, p12Pin){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}

	lRet = SecCtrl.KS_ImportP12Cert(certType, base64P12Cert, p12Pin);

	return lRet;
}

/**
 * 删除证书
 * return: 返回错误码，0成功，其他失败
 */
function RemoveCert(){
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}

	lRet = SecCtrl.KS_RemoveCert();

	return lRet;
}

/**
 * 设置默认key，本次操作不遍历此key
 */
function setDefaultKey(certSn){
	//选择默认key
	SecCtrl.KS_SetParam("managersn", certSn);
}

/**
 * 设备序列号
 * return：设备序列号
 */
function GetAllDeviceSerialNumber(){
	var result = "";
	var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	result = SecCtrl.KS_GetAllDeviceSerialNumber();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 印章写入
 * return：成功失败
 */
function WriteSESToKey(json){
	var result = "";
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	SecCtrl.KS_SetConfigToKey(result);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}else{
		return true;
	}
	return result;
}

//读取印章信息
function ReadSESInfoFromKey(type){
	var result = "";
	result = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var sealList = "";
	sealList = SecCtrl.KS_GetSealList();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var sealData = SecCtrl.KS_GetSeal(sealList);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var picData = SecCtrl.KS_GetInfoFromSeal(sealData,type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	return picData;
}

//删除印章信息
function DeleteSESFileFromKey(){
	var result = "";
	SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}

	result = SecCtrl.KS_DeleteFromKey();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	return result;
}



//新增函数
/**
* 获取插Key状态
*/
// function GetDeviceStatus() {
//     var result = "";
//     var lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
//     if (lRet == 0)
//         result = SecCtrl.KS_GetDeviceStatus();
//     else
//         result = "SetProv error.";
//     return result;
// }

/**
 * 数据签名P7
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：签名数据
 */
function XACASignDataByP7(indata, hashAlg){
	var result = "";
	SecCtrl.KS_SetParam("signtype", "pksc7");
	result = SecCtrl.KS_SignData(indata, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}
/**
* 获取插KeyVid
*/
function XACAGetDeviceVid() {
    var result = "";
    result = SecCtrl.KS_GetDeviceVid()
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
    return result;
}

/**
 * 初始化函数，设置相关初始值
 * p_provider: 算法提供者
 * p_alg: 非对称算法，1-RSA1024, 2-RSA2048, 3-ECC
 * p_path: 路径
 */
function initXACA(p_provider, p_alg, p_path){
    if(p_provider != null && p_provider != ""){
    	ks_provider = p_provider;
    }
    if(p_alg != null && p_alg != ""){
    	ks_alg = p_alg;
    }
    if(p_path != null && p_path != ""){
    	ks_path = p_path;
    }
	SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
}

/**
 * 获取版本号
 */
function XACAGetVersion(){
	var result = "";
	result = SecCtrl.KS_GetVersion();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 设置过滤器，在算法提供者为soft_ie的时候适用
 * filter: 参数;
例如:CERT_SN=1234&ISSUER_C=CN&ISSUER_CN=测试证书&ISSUER_O=测试单位&ISSUER_OU=测试证书&ISSUER_L=城市&ISSUER_S=省份&ISSUER_E=yangxunx@foxmail.com&SUBJECT_C=CN&SUBJECT_CN=测试证书&SUBJECT_O=测试单位&SUBJECT_OU=测试证书&SUBJECT_L=城市&SUBJECT_S=省份&SUBJECT_E=yangxunx@foxmail.com
 */
 function XACASetFilter(filter){
	var result = "";
	result = SecCtrl.KS_SetParam("filter", filter);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
 }

/**
 * 生成密钥对，返回Base64编码的公钥
 * signCert: Base64编码签名证书
 */
function XACAGenKeyPair(){
	var result = "";
	result = SecCtrl.KS_GenKeyPair();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成密钥对，返回Base64编码的公钥
 * signCert: Base64编码签名证书
 * certsn  : 排除此证书序列号的key
 */
function XACAGenKeyPairEx(certsn){
	var result = "";
	SecCtrl.KS_SetParam("managersn", certsn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	result = SecCtrl.KS_GenKeyPair();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成证书请求文件
 * dn: 格式为C=CN,CN=测试,O=测试组织,OU=测试部门,L=上海市,S=上海市，E=admin@163.com
 * hashAlg: 签名摘要算法
 */
function XACAMakeP10(dn, hashAlg){
	var result = "";
	//填充默认密码
	SecCtrl.KS_SetParam("defaultpin","111111");
	result = SecCtrl.KS_MakeP10(dn, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成证书请求文件（双key，排除管理员key）
 * dn: 格式为C=CN,CN=测试,O=测试组织,OU=测试部门,L=上海市,S=上海市，E=admin@163.com
 * hashAlg: 签名摘要算法
 * certsn  : 排除此证书序列号的key
 */
function XACAMakeP10Ex(dn, hashAlg,certsn){
	var result = "";
	SecCtrl.KS_SetParam("managersn", certsn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	result = SecCtrl.KS_MakeP10(dn, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 保存证书
 * signCert: Base64编码签名证书
 * encCert : Base64编码加密证书
 * encKey  : Base64编码加密私钥
 */
function XACASaveCert(signCert, encCert, encKey){
	SecCtrl.KS_SetParam("defaultpin", "111111");
	var lRet = SecCtrl.KS_SaveCert(signCert, encCert, encKey);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}

/**
 * 保存证书
 * signCert: Base64编码签名证书
 * encCert : Base64编码加密证书
 * encKey  : Base64编码加密私钥
 * certsn  : 排除此证书序列号的key
 */
function XACASaveCertEx(signCert, encCert, encKey,certSn){
	//设置管理员key
	SecCtrl.KS_SetParam("managersn", certSn);
	SecCtrl.KS_SetParam("defaultpin", "111111");
	var lRet = SecCtrl.KS_SaveCert(signCert, encCert, encKey);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}

/**
 * 保存证书链
 * p7bCertChain: Base64编码的P7B格式证书链
 */
function XACASaveCertChain(p7bCertChain){

	var lRet = SecCtrl.KS_SaveCertChain(signCertp7bCertChain);
	if(lRet != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return false;
	}
	return true;
}


/**
 * 获取BASE64编码证书
 * type: 1、加密证书，2、签名证书
 */
function XACAGetCert(type){
	var result = "";
	result = SecCtrl.KS_GetCert(type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 获取BASE64编码证书(管理员)
 * type: 1、加密证书，2、签名证书
 */
function XACAGetCertManager(type){
	var result = "";

	//选择默认key
	SecCtrl.KS_SetParam("managersn", "");
	//设置默认key
	SecCtrl.KS_SetParam("bmanager", "false");

	result = SecCtrl.KS_GetCert(type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 获取证书信息
 * cert: Base64编码证书
 * item: 解析项。
 * 1、证书版本；2、证书序列号；3、证书签名算法标识；4、证书颁发者国家(C); 5、证书颁发者组织名(O);
 * 6、证书颁发者部门名(OU); 7、证书颁发者所在的省、自治区、直辖市(S); 8、证书颁发者通用名称(CN); 9、证书颁发者所在的城市、地区(L);
 * 10、证书颁发者Email; 11、证书有效期：起始日期; 12、证书有效期：终止日期; 13、证书拥有者国家(C ); 14、证书拥有者组织名(O);
 * 15、证书拥有者部门名(OU); 16、证书拥有者所在的省、自治区、直辖市(S); 17、证书拥有者通用名称(CN); 18、证书拥有者所在的城市、地区(L);
 * 19、证书拥有者Email; 20、证书颁发者DN; 21、证书拥有者DN; 22、证书公钥信息; 23、CRL发布点.
 */
// function XACAGetCertInfo(cert, item){
// 	var result = "";

// 	result = SecCtrl.KS_GetCertInfo(cert, item);
// 	if(SecCtrl.KS_GetLastErrorCode() != 0){
// 		alert(SecCtrl.KS_GetLastErrorMsg());
// 	}
// 	return result;
// }

/**
 * 获取证书扩展信息
 * cert: Base64编码证书
 * oid: oid值
 */
function XACAGetCertInfoByOid(cert, oid){
	var result = "";


	result = SecCtrl.KS_GetCertInfoByOid(cert, oid);
	if(SecCtrl.KS_GetLastErrorCode() != 0 && SecCtrl.KS_GetLastErrorCode() != 0X0002014){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 生成随机数
 * len: 随机数长度
 */
function XACAGenRandom(len){
	var result = "";

	result = SecCtrl.KS_GenRandom(len);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 数据摘要
 * indata: 输入数据
 * hashAlg:摘要算法。1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4
 */
function XACAHashData(indata, hashAlg){
	var result = "";

	result = SecCtrl.KS_HashData(indata, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 文件摘要
 * filepath: 输入文件路径
 * hashAlg:摘要算法。1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4
 */
function XACAHashFile(filepath, hashAlg){
	var result = "";

	result = SecCtrl.KS_HashFile(filepath, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}
/**
 * 数据签名
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：签名数据
 */
function XACASignData(indata, hashAlg){
	var result = "";

	result = SecCtrl.KS_SignData(indata, hashAlg);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 双key操作时，使用证书序列号对应的key进行签名
 * indata：明文数据
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * certSn:  管理员证书序列号
 * return：签名数据
 */
function XACASignDataManager(indata, hashAlg,certSn){
	var result = "";

	//选择默认key
	SecCtrl.KS_SetParam("managersn", certSn.toLowerCase());
	//设置默认key
	SecCtrl.KS_SetParam("bmanager", "true");

	result = SecCtrl.KS_SignData(indata, hashAlg);
	if(result == ""){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return result;
	}
	return result;
}

/**
 * 数据验签
 * indata：明文数据
 * signdata：签名数据
 * cert: 证书
 * hashAlg: 1-SHA1, 2-SHA256, 3-SHA512, 4-MD5, 5-MD4, 6-SM3
 * return：成功=true，失败=false
 */
function XACAVerifySignData(indata, signdata, cert, hashAlg){
  var result = "";
  if(IsIE()){
    result = SecCtrl.KS_VerifySignData(indata, signdata, cert, hashAlg);
    if(SecCtrl.KS_GetLastErrorCode() != 0){
      alert(SecCtrl.KS_GetLastErrorMsg());
    }
    return result;
  }else{
    result=KS_VerifySignDatas(indata, signdata, cert, hashAlg);
    return result;
  }
}

/**
 * 导入P12到设备中
 * certType: 证书类型, 1加密证书 , 2签名证书
 * base64P12Cert: P12证书
 * p12Pin: P12密码
 * return: 返回错误码，0成功，其他失败
 */
function XACAImportP12Cert(certType, base64P12Cert, p12Pin){
	var lRet = SecCtrl.KS_ImportP12Cert(certType, base64P12Cert, p12Pin);

	return lRet;
}

/**
 * 删除证书
 * return: 返回错误码，0成功，其他失败
 */
function XACARemoveCert(){

	var lRet = SecCtrl.KS_RemoveCert();

	return lRet;
}


/**
 * 设备序列号
 * return：设备序列号
 */
function XACAGetAllDeviceSerialNumber(){
	var result = "";
	result = SecCtrl.KS_GetAllDeviceSerialNumber();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 印章写入
 * return：成功失败
 */
function XACAWriteSESToKey(json){
	var result = "";
	SecCtrl.KS_SetConfigToKey(json);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}else{
		return true;
	}
	return result;
}

//读取印章信息
function XACAReadSESInfoFromKey(type){
	var result = "";
	var sealList = "";
	sealList = SecCtrl.KS_GetSealList();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var sealData = SecCtrl.KS_GetSeal(sealList);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var picData = SecCtrl.KS_GetInfoFromSeal(sealData,type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	return picData;
}

/**
 * 获取key中印章信息
 */

function XACASealInfoFromKey(type){
	var sealList = "";
	sealList = SecCtrl.KS_GetSealList();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	var sealData = SecCtrl.KS_GetSeal(sealList);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	return sealData;
}

//删除印章信息
function XACADeleteSESFileFromKey(){
	var result = "";
	result = SecCtrl.KS_DeleteFromKey();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
		return SecCtrl.KS_GetLastErrorCode();
	}
	return result;
}

/**
 * 制作数字信封
 */
function MakeEnvelope(indata, enccert){
	var result = "";
	SecCtrl.KS_SetParam("defaultCert","true");
	result = SecCtrl.KS_MakeEnvelope(indata, enccert);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 打开数字信封
 */
function OpenEnvelope(envelope){
	var result = "";
	SecCtrl.KS_SetParam("defaultCert",true);
	result = SecCtrl.KS_OpenEnvelope(envelope);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 会话密钥加密数据
 *
 */
function sessionKeyEncrypt(indata,key){
	var result = "";
	result = SecCtrl.KS_SymmEncrypt(indata,key,11);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 会话密钥解密数据
 *
 */
function sessionKeyDecrypt(encData,key){
	var result = "";
	result = SecCtrl.KS_SymmDecrypt(encData,key,11);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * sm3算法获取hash值
 */
function sm3HashData(indata){
	var result = "";
	result = SecCtrl.KS_UniversalHashData(indata,"",6);

	return result;
}

/**
 * 解析证书项
 */
function XACAGetCertInfo(cert,type){
	var result = "";
	result = SecCtrl.KS_GetCertInfo(cert,type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 解析印章项
 */
function XACAGetSealInfo(seal,type){
	var result = "";
	result = SecCtrl.KS_GetInfoFromSeal(seal,type);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 验证印章数据
 */
function XACAVerifySealData(data){
	var result="";
	result = SecCtrl.KS_VerifySeal(data);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 验证签章数据
 */
function XACAVerifySignSealData(data){
	var result="";
	result = SecCtrl.KS_VerifyESignSeal(data);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 验证证书有效性
 */
function XACAVerifyCertInfo(cert){
	var result="";
	result = SecCtrl.KS_VerifyCertVaild(cert);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 印章数据转asn1
 * return：成功失败
 */
function XACAGetASN1ByParseJSON(json) {
	var result = "";
	result = SecCtrl.KS_ZWFWGetASN1ByParseJSON(json, 2);
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 印章待签数据转asn1
 * return：成功失败
 */
function XACAGetASN1ByParseTbsSignData(json) {
	var result = "";
	result = SecCtrl.KS_ZWFWGetInDataASN1ByParseJSON(json, 1);
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 国办格式印章写入
 * return：成功失败
 */
function XACAWriteZWFWSESToKey(json){
	var result = "";
	SecCtrl.KS_SetZWFWSealToKey(json);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}else{
		return true;
	}
	return result;
}

/**
 * 获取国办印章图片
 */
function XACAReadZWFWSESToKey(){
	var result = "";
	result = SecCtrl. KS_GetZWFWSealList();
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}

	var sealData = SecCtrl.KS_GetZWFWSeal(result);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	var sealImg = SecCtrl.KS_GetInfoFromZWFWSeal(sealData,1);
	if(SecCtrl.KS_GetLastErrorCode() != 0){
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return sealImg;
}


/**
 * 写入公安数据
 */
function XACAWriteGBPoliceData(json){
	var result = "";
	result = SecCtrl.KS_WriteGBPoliceData(json,0);
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}


/**
 * 读出公安数据
 */
function XACReadGBPoliceData(){
	var result = "";
	result = SecCtrl.KS_ReadGBPoliceData();
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}

/**
 * 解析公安数据
 */
function XACAGetGBPoliceDataInfo(indata,num){
	var result = "";
	result = SecCtrl.KS_GetGBPoliceDataInfo(indata, num);
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
}


/**
 * 控件认证
 */
 function XACAGetDataForDev(indata){
 	var result = "";
	result = SecCtrl.KS_GetDataForDev(indata,9);
	if (SecCtrl.KS_GetLastErrorCode() != 0) {
		alert(SecCtrl.KS_GetLastErrorMsg());
	}
	return result;
 }

export {
   XACAVerifySignData,
  init,
  GetDeviceStatus,
  GetCertManager,
  GetCertInfo,
  SignData,
  GetCert
};












// WEBPACK FOOTER //
// ./src/response/secCtrl.js